import React from 'react';
import { OutliersConfigState } from 'widgets/outliers/store/config/OutliersConfigState';
import { Icon } from '@instinet-analytics/semantic-ui-components';
import { useSelectLocked } from 'layoutRenderer/store/selectors';
import { usePortfolioReturnsConfigSlice } from 'widgets/portfolioReturns/store/configuration/configSlice';
import { usePortfolioReturnsPriceMovementVersus } from 'widgets/portfolioReturns/usePortfolioReturnsPriceMovementVersus';

import './PortfolioReturnsTitlePanel.scss';

export function PortfolioReturnsTitlePanel() {
    const { config, dispatchConfigChanged } = usePortfolioReturnsConfigSlice();
    const isLocked = useSelectLocked();

    const { hideTitlePanel } = config;
    const { priceMovementVersusDescription } =
        usePortfolioReturnsPriceMovementVersus();

    if (hideTitlePanel) {
        return <></>;
    }

    const handleCloseClick = () => {
        const delta: Partial<OutliersConfigState> = {
            hideTitlePanel: true,
        };
        dispatchConfigChanged(delta);
    };

    return (
        <div className="PortfolioReturnsTitlePanel">
            <div>
                <div>
                    Price Movement Versus {priceMovementVersusDescription}
                </div>
                {!isLocked && <Icon name="close" onClick={handleCloseClick} />}
            </div>
        </div>
    );
}
